export const CACHE_CONTROL_VALUE = 'max-age=31536000';
export const REGION = 'us-east-1';
export const IDENTITY_POOL_ID =
    'us-east-1:f583f983-da94-4af6-921a-2efa5e42412a';
export const BUCKET_HOSTNAME_S3 = 'https://s3.amazonaws.com';
export const BUCKET_HOSTNAME_CDN = 'https://cdn.motorfy.com';
export const BUCKET_NAME = 'motorfy-latamautos-files';
